import { useJsApiLoader } from '@react-google-maps/api';
const libraries = ['places'];
export const useGoogleApi = (googleApiKey) => useJsApiLoader({
    googleMapsApiKey: googleApiKey,
    libraries,
});
